<template>
  <div class="gridCard" :style="{gridTemplateColumns: `repeat(${column}, minmax(${min}px, 1fr))`, gridGap: `${gap}px`}">
    <slot name="item"></slot>
  </div>
</template>

<script>
export default {
  name: 'adx-grid-card',
  props: {
    min: {
      required: true
    },
    column: {
      required: true
    },
    gap: {
      type: Number,
      required: false
    }
  }
}
</script>

<style lang='scss' scoped>
@import './index.scss';
</style>